module.exports = __webpack_public_path__ + "img/podcast.e564213.png";